import { useState } from 'react';

export default function HomePage() {
  const [showMore, setShowMore] = useState(false);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'ソイプロテインとホエイプロテインの違いは何ですか?',
      answer: 'ソイプロテインは大豆由来の植物性タンパク質で、ホエイプロテインは牛乳由来の動物性タンパク質です。ソイプロテインは吸収がゆっくりで腹持ちが良く、イソフラボンなど女性に嬉しい成分も含まれています。'
    },
    {
      question: 'ソイプロテインはいつ飲むのが効果的ですか?',
      answer: '目的によって異なります。ダイエット目的なら食事の置き換えとして朝食や夕食時、筋肉維持なら運動後30分以内、美容目的なら就寝前がおすすめです。継続することが最も重要です。'
    },
    {
      question: 'ソイプロテインで太ることはありますか?',
      answer: 'プロテイン自体は低カロリーですが、過剰摂取や食事にプラスして飲むと総カロリーが増えて太る可能性があります。食事のバランスを考えながら適量を摂取することが大切です。'
    },
    {
      question: '男性がソイプロテインを飲んでも大丈夫ですか?',
      answer: 'はい、問題ありません。ソイプロテインに含まれる大豆イソフラボンは適量であれば健康に良い影響を与えます。筋肉づくりやダイエット、健康維持に男性にもおすすめです。'
    },
    {
      question: 'ソイプロテインは毎日飲んでも大丈夫ですか?',
      answer: 'はい、毎日飲んでも問題ありません。ただし、1日の推奨摂取量を守り、バランスの良い食事と組み合わせることが重要です。体調に異変を感じた場合は医師に相談してください。'
    },
    {
      question: 'ソイプロテインの保存方法は?',
      answer: '直射日光を避け、湿気の少ない涼しい場所で保管してください。開封後は密閉容器に入れ、なるべく早めに使い切ることをおすすめします。冷蔵庫での保管は結露の原因になるため避けましょう。'
    },
    {
      question: 'ソイプロテインと他のサプリメントを併用できますか?',
      answer: '基本的には併用可能です。ただし、タンパク質やビタミンなどの過剰摂取にならないよう、各製品の成分表示を確認してください。心配な場合は医師や薬剤師に相談することをおすすめします。'
    },
    {
      question: 'ソイプロテインの効果を実感できるまでどのくらいかかりますか?',
      answer: '個人差がありますが、継続して飲むことで2〜3ヶ月程度で体の変化を実感する方が多いです。ダイエットや筋肉づくりの効果は、運動や食事管理と組み合わせることでより早く現れます。'
    }
  ];

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative bg-primary-light">
        <div className="max-w-7xl mx-auto">
          <div className="relative">
            <div className="absolute top-4 right-4 bg-white px-3 py-1 rounded shadow-md z-10">
              <span className="text-xs font-bold text-gray-700">PR</span>
            </div>
            <img 
              src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/c6ca3411f0e894e83076e5aead31a14a.png" 
              alt="2026最新 女性向けソイプロテインおすすめBEST5 安さ おいしさ ダイエット" 
              className="w-full h-auto"
              width={960}
              height={593}
            />
          </div>
        </div>
      </section>

      {/* MiniRanking Section */}
      <section className="pt-6 pb-12 bg-gradient-to-b from-primary-light to-primary">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-block mb-4">
              <span className="text-white text-sm font-bold px-6 py-2 rounded-full shadow-lg" style={{ backgroundColor: '#c85842' }}>
                美容やダイエットをするなら！
              </span>
            </div>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-black text-gray-800 mb-4">
              <span style={{ color: '#c85842' }}>女性向けソイプロテイン<br /></span>選ぶならこれ！
            </h2>
            <p className="text-sm md:text-base text-gray-600 max-w-2xl mx-auto">
              編集部が厳選したおすすめ商品をご紹介！
            </p>
          </div>

          <div className="overflow-x-auto pb-4">
            <div className="flex gap-6 min-w-max md:justify-center">
              {/* SOY it protein */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden w-[240px] md:w-[320px] flex-shrink-0">
                <a href="https://soyproteinranking.com/web/SOYit.php?p=mini" target="_blank" rel="nofollow noopener" className="relative block">
                  <div className="absolute top-0 left-0 w-12 h-12 md:w-16 md:h-16 flex items-center justify-center z-10 shadow-lg" style={{ background: 'linear-gradient(to bottom right, #f6c344, #c85842)', clipPath: 'polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%)' }}>
                    <span className="text-white font-black text-lg md:text-2xl drop-shadow-md" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>1</span>
                  </div>
                  <img 
                    src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/eae272bb32f71e22efba292f15423341.png" 
                    alt="SOY it protein" 
                    className="w-full h-36 md:h-48 object-cover"
                    width={230}
                    height={192}
                  />
                </a>
                <div className="p-4 md:p-6">
                  <h3 className="text-base md:text-xl font-bold text-gray-800 mb-2">SOY it protein</h3>
                  <p className="text-xs md:text-sm font-bold mb-3" style={{ color: '#c85842' }}>1杯あたり100円以下！◎</p>
                  <ul className="space-y-1.5 md:space-y-2">
                    <li className="flex items-start text-xs md:text-sm">
                      <i className="ri-check-line text-primary-dark mr-2 mt-0.5"></i>
                      <span><strong>初回 1,480円(税込) / 15日分</strong></span>
                    </li>
                    <li className="flex items-start text-xs md:text-sm">
                      <i className="ri-check-line text-primary-dark mr-2 mt-0.5"></i>
                      <span>脂肪を燃やすのを助ける成分配合!</span>
                    </li>
                    <li className="flex items-start text-xs md:text-sm">
                      <i className="ri-check-line text-primary-dark mr-2 mt-0.5"></i>
                      <span>シェイカーなしでもサッと溶ける</span>
                    </li>
                  </ul>
                  <a 
                    href="https://soyproteinranking.com/web/SOYit.php?p=mini" 
                    target="_blank" 
                    rel="nofollow noopener"
                    className="block w-full hover:opacity-90 text-white text-center font-bold py-2.5 md:py-3 text-base md:text-lg rounded-full transition-all cursor-pointer whitespace-nowrap"
                    style={{ background: 'linear-gradient(to bottom, #3da421, #2d7a18)', position: 'relative', overflow: 'hidden' }}
                  >
                    <span className="absolute inset-0 overflow-hidden rounded-full">
                      <span className="absolute inset-0 -translate-x-full animate-[shine_2s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-white/40 to-transparent"></span>
                    </span>
                    <span className="relative">公式サイトを見る</span>
                  </a>
                </div>
              </div>

              {/* KOREDAKE */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden w-[240px] md:w-[320px] flex-shrink-0">
                <a href="https://readdy.cc/preview/2ecd2b52-32b9-4ad2-89d7-448bb5097ea2/6309244" target="_blank" rel="nofollow noopener" className="relative block">
                  <div className="absolute top-0 left-0 w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-gray-300 to-gray-400 flex items-center justify-center z-10 shadow-lg" style={{ clipPath: 'polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%)' }}>
                    <span className="text-white font-black text-lg md:text-2xl drop-shadow-md" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>2</span>
                  </div>
                  <img 
                    src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/5a7504435b5a35b93de1e70aba95944a.png" 
                    alt="KOREDAKE" 
                    className="w-full h-36 md:h-48 object-cover"
                    width={230}
                    height={192}
                  />
                </a>
                <div className="p-4 md:p-6">
                  <h3 className="text-base md:text-xl font-bold text-gray-800 mb-2">KOREDAKE</h3>
                  <p className="text-xs md:text-sm font-bold text-primary-dark mb-3">先着キャンペーンあり</p>
                  <ul className="space-y-1.5 md:space-y-2">
                    <li className="flex items-start text-xs md:text-sm">
                      <i className="ri-check-line text-primary-dark mr-2 mt-0.5"></i>
                      <span><strong>初回 1,480円(税込) / 5日分</strong></span>
                    </li>
                    <li className="flex items-start text-xs md:text-sm">
                      <i className="ri-check-line text-primary-dark mr-2 mt-0.5"></i>
                      <span>5種類の味から選べる</span>
                    </li>
                    <li className="flex items-start text-xs md:text-sm">
                      <i className="ri-check-line text-primary-dark mr-2 mt-0.5"></i>
                      <span>100万食突破</span>
                    </li>
                  </ul>
                  <a 
                    href="https://readdy.cc/preview/2ecd2b52-32b9-4ad2-89d7-448bb5097ea2/6309244" 
                    target="_blank" 
                    rel="nofollow noopener"
                    className="block w-full hover:opacity-90 text-white text-center font-bold py-2.5 md:py-3 text-base md:text-lg rounded-full transition-all cursor-pointer whitespace-nowrap"
                    style={{ background: 'linear-gradient(to bottom, #3da421, #2d7a18)', position: 'relative', overflow: 'hidden' }}
                  >
                    <span className="absolute inset-0 overflow-hidden rounded-full">
                      <span className="absolute inset-0 -translate-x-full animate-[shine_2s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-white/40 to-transparent"></span>
                    </span>
                    <span className="relative">公式サイトを見る</span>
                  </a>
                </div>
              </div>

              {/* 私の完全美容食 */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden w-[240px] md:w-[320px] flex-shrink-0">
                <a href="https://soyproteinranking.com/web/kanzen.php?p=mini" target="_blank" rel="nofollow noopener" className="relative block">
                  <div className="absolute top-0 left-0 w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-amber-600 to-amber-700 flex items-center justify-center z-10 shadow-lg" style={{ clipPath: 'polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%)' }}>
                    <span className="text-white font-black text-lg md:text-2xl drop-shadow-md" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>3</span>
                  </div>
                  <div className="w-full h-36 md:h-48 flex items-center justify-center bg-white p-4">
                    <img 
                      src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/7336cabfb610fcfeb0e5636fad785bcd.jpeg" 
                      alt="私の完全美容食" 
                      className="w-full h-full object-contain"
                      width={230}
                      height={192}
                    />
                  </div>
                </a>
                <div className="p-4 md:p-6">
                  <h3 className="text-base md:text-xl font-bold text-gray-800 mb-2">私の完全美容食</h3>
                  <p className="text-xs md:text-sm font-bold text-primary-dark mb-3">国産素材で安心</p>
                  <ul className="space-y-1.5 md:space-y-2">
                    <li className="flex items-start text-xs md:text-sm">
                      <i className="ri-check-line text-primary-dark mr-2 mt-0.5"></i>
                      <span><strong>初回 4,980円(税込) / 28日分</strong></span>
                    </li>
                    <li className="flex items-start text-xs md:text-sm">
                      <i className="ri-check-line text-primary-dark mr-2 mt-0.5"></i>
                      <span>黒糖プレーン味で飲みやすい</span>
                    </li>
                    <li className="flex items-start text-xs md:text-sm">
                      <i className="ri-check-line text-primary-dark mr-2 mt-0.5"></i>
                      <span>管理栄養士推薦</span>
                    </li>
                  </ul>
                  <a 
                    href="https://soyproteinranking.com/web/kanzen.php?p=mini" 
                    target="_blank" 
                    rel="nofollow noopener"
                    className="block w-full hover:opacity-90 text-white text-center font-bold py-2.5 md:py-3 text-base md:text-lg rounded-full transition-all cursor-pointer whitespace-nowrap"
                    style={{ background: 'linear-gradient(to bottom, #3da421, #2d7a18)', position: 'relative', overflow: 'hidden' }}
                  >
                    <span className="absolute inset-0 overflow-hidden rounded-full">
                      <span className="absolute inset-0 -translate-x-full animate-[shine_2s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-white/40 to-transparent"></span>
                    </span>
                    <span className="relative">公式サイトを見る</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Checklist Section */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <img 
            src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/4d7c02b81492c21553b37037d32b6cc0.png" 
            alt="商品矯正するならおさえておきたいチェックリスト" 
            className="w-full h-auto rounded-lg shadow-lg"
            width={640}
            height={800}
          />
        </div>
      </section>

      {/* Comparison Table Section */}
      <section className="py-16 bg-gradient-to-b from-primary-light to-white relative overflow-hidden">
        <div className="absolute top-0 left-0 w-64 h-64 bg-red-100 rounded-full blur-3xl opacity-30 -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-green-100 rounded-full blur-3xl opacity-20 translate-x-1/3 translate-y-1/3"></div>
        
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <div className="inline-block mb-4">
              <span className="text-white text-sm font-bold px-6 py-2 rounded-full shadow-lg" style={{ backgroundColor: '#c85842' }}>
                料金と効果で選ぶ！
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-800 mb-4">
              ソイプロテイン<span style={{ color: '#c85842' }}>徹底比較</span>
            </h2>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
              人気のソイプロテイン5つを比べてみました！
            </p>
          </div>
          
          <div className="rounded-2xl shadow-2xl p-4 md:p-8 bg-white">
            <p className="text-center text-sm md:text-base text-gray-600 mb-4 md:mb-6 font-medium flex items-center justify-center gap-2">
              <i className="ri-arrow-left-right-line" style={{ color: '#c85842' }}></i>
              <span>←スクロールできます→</span>
              <i className="ri-arrow-left-right-line" style={{ color: '#c85842' }}></i>
            </p>
            
            <div className="overflow-x-auto rounded-xl">
              <table className="w-full min-w-[900px] border-collapse table-fixed">
                <thead>
                  <tr style={{ backgroundColor: '#cb827c' }}>
                    <th className="border border-gray-300 py-4 px-3 text-sm md:text-base font-black text-white whitespace-nowrap w-[140px]">
                      ソイプロテイン<br />ブランド
                    </th>
                    <th className="border border-gray-300 py-4 px-3 text-sm md:text-base font-black text-white whitespace-nowrap w-[120px]">
                      総合評価
                    </th>
                    <th className="border border-gray-300 py-4 px-3 text-sm md:text-base font-black text-white whitespace-nowrap w-[120px]">
                      コスパ
                    </th>
                    <th className="border border-gray-300 py-4 px-3 text-sm md:text-base font-black text-white whitespace-nowrap w-[120px]">
                      飲みやすさ
                    </th>
                    <th className="border border-gray-300 py-4 px-3 text-sm md:text-base font-black text-white whitespace-nowrap w-[180px]">
                      おすすめポイント
                    </th>
                    <th className="border border-gray-300 py-4 px-3 text-sm md:text-base font-black text-white whitespace-nowrap w-[130px]">
                      公式サイト
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* 1位 - 強調枠線 */}
                  <tr style={{ backgroundColor: '#fbf6c5', outline: '4px solid #f6c344', outlineOffset: '-4px' }}>
                    <td className="border border-gray-300 py-4 px-3 text-center relative h-[140px]">
                      <div className="absolute top-0 left-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center z-10 shadow-xl" style={{ background: 'linear-gradient(to bottom right, #ffd700, #f6c344, #daa520)', clipPath: 'polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%)' }}>
                        <span className="text-white font-black text-lg md:text-xl drop-shadow-lg" style={{ textShadow: '2px 2px 6px rgba(0,0,0,0.4)' }}>1</span>
                      </div>
                      <div className="flex flex-col items-center justify-center pt-2">
                        <a href="https://soyproteinranking.com/web/SOYit.php?p=hikaku" target="_blank" rel="nofollow noopener" className="inline-block mb-2">
                          <img 
                            src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/210d0942c2ac6fb15db9646e3c41adb9.jpeg" 
                            alt="SOY it protein" 
                            className="w-[80px] md:w-[90px] h-auto object-contain"
                          />
                        </a>
                        <a href="https://soyproteinranking.com/web/SOYit.php?p=hikaku" target="_blank" rel="nofollow noopener" className="text-sm md:text-base font-bold hover:underline" style={{ color: '#3B82F6' }}>
                          SOY it protein ＞
                        </a>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-[5px] flex items-center justify-center" style={{ borderColor: '#c85842' }}>
                          <div className="w-4 h-4 md:w-5 md:h-5 rounded-full border-[4px]" style={{ borderColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">機能性表示食品で<br />脂肪燃焼にぴったり！</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-[5px] flex items-center justify-center" style={{ borderColor: '#c85842' }}>
                          <div className="w-4 h-4 md:w-5 md:h-5 rounded-full border-[4px]" style={{ borderColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">1杯あたり98.7円<br />1,480円/15日分</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-[5px] flex items-center justify-center" style={{ borderColor: '#c85842' }}>
                          <div className="w-4 h-4 md:w-5 md:h-5 rounded-full border-[4px]" style={{ borderColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">シェイカー不要で<br />溶ける手軽さ</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <p className="text-xs md:text-sm font-bold text-gray-800 leading-relaxed">
                        成分が肥満気味な方の<br />体重やお腹の脂肪を減らす<br />のを助ける！
                      </p>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-2">
                        <a 
                          href="https://soyproteinranking.com/web/SOYit.php?p=hikaku" 
                          target="_blank" 
                          rel="nofollow noopener"
                          className="inline-block bg-gradient-to-b from-green-500 to-green-700 hover:from-green-600 hover:to-green-800 text-white font-black py-2 px-4 rounded-lg text-xs md:text-sm whitespace-nowrap transition-all cursor-pointer shadow-lg"
                        >
                          公式サイトへ ＞
                        </a>
                      </div>
                    </td>
                  </tr>

                  {/* 2位 */}
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="border border-gray-300 py-4 px-3 text-center relative h-[140px]">
                      <div className="absolute top-0 left-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center z-10 shadow-lg" style={{ background: 'linear-gradient(to bottom right, #e8e8e8, #c0c0c0, #a8a8a8)', clipPath: 'polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%)' }}>
                        <span className="text-white font-black text-lg md:text-xl drop-shadow-md" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>2</span>
                      </div>
                      <div className="flex flex-col items-center justify-center pt-2">
                        <a href="https://readdy.cc/preview/2ecd2b52-32b9-4ad2-89d7-448bb5097ea2/6309244" target="_blank" rel="nofollow noopener" className="inline-block mb-2">
                          <img 
                            src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/72dc85e248d71151800ad736f69b2e67.jpeg" 
                            alt="KOREDAKE" 
                            className="w-[80px] md:w-[90px] h-auto object-contain"
                          />
                        </a>
                        <a href="https://readdy.cc/preview/2ecd2b52-32b9-4ad2-89d7-448bb5097ea2/6309244" target="_blank" rel="nofollow noopener" className="text-sm md:text-base font-bold hover:underline" style={{ color: '#3B82F6' }}>
                          KOREDAKE ＞
                        </a>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-[5px] flex items-center justify-center" style={{ borderColor: '#c85842' }}>
                          <div className="w-4 h-4 md:w-5 md:h-5 rounded-full border-[4px]" style={{ borderColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">置き換えダイエットに<br />ぴったり</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                          <div className="w-0 h-0 border-l-[20px] md:border-l-[24px] border-r-[20px] md:border-r-[24px] border-b-[32px] md:border-b-[40px] border-l-transparent border-r-transparent" style={{ borderBottomColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">1杯あたり296円<br />1,480円/5日分</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-[5px] flex items-center justify-center" style={{ borderColor: '#c85842' }}>
                          <div className="w-4 h-4 md:w-5 md:h-5 rounded-full border-[4px]" style={{ borderColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">人工甘味料不使用<br />自然な甘み</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <p className="text-xs md:text-sm font-bold text-gray-800 leading-relaxed">
                        栄養士監修！<br />女性に不足しがちな栄養を摂れる
                      </p>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-2">
                        <a 
                          href="https://readdy.cc/preview/2ecd2b52-32b9-4ad2-89d7-448bb5097ea2/6309244" 
                          target="_blank" 
                          rel="nofollow noopener"
                          className="inline-block bg-gradient-to-b from-green-500 to-green-700 hover:from-green-600 hover:to-green-800 text-white font-black py-2 px-4 rounded-lg text-xs md:text-sm whitespace-nowrap transition-all cursor-pointer shadow-lg"
                        >
                          公式サイトへ ＞
                        </a>
                      </div>
                    </td>
                  </tr>

                  {/* 3位 */}
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="border border-gray-300 py-4 px-3 text-center relative h-[140px]">
                      <div className="absolute top-0 left-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center z-10 shadow-lg" style={{ background: 'linear-gradient(to bottom right, #cd7f32, #b87333, #a0522d)', clipPath: 'polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%)' }}>
                        <span className="text-white font-black text-lg md:text-xl drop-shadow-md" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>3</span>
                      </div>
                      <div className="flex flex-col items-center justify-center pt-2">
                        <a href="https://soyproteinranking.com/web/kanzen.php?p=hikaku" target="_blank" rel="nofollow noopener" className="inline-block mb-2">
                          <img 
                            src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/3e08286b8bfd25095d7fdbea894f1c87.jpeg" 
                            alt="私の完全美容食" 
                            className="w-[80px] md:w-[90px] h-auto object-contain"
                          />
                        </a>
                        <a href="https://soyproteinranking.com/web/kanzen.php?p=hikaku" target="_blank" rel="nofollow noopener" className="text-sm md:text-base font-bold hover:underline" style={{ color: '#3B82F6' }}>
                          私の完全美容食 ＞
                        </a>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-[5px] flex items-center justify-center" style={{ borderColor: '#c85842' }}>
                          <div className="w-4 h-4 md:w-5 md:h-5 rounded-full border-[4px]" style={{ borderColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">国産原料で<br />体にやさしい</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                          <div className="w-0 h-0 border-l-[20px] md:border-l-[24px] border-r-[20px] md:border-r-[24px] border-b-[32px] md:border-b-[40px] border-l-transparent border-r-transparent" style={{ borderBottomColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">1杯あたり<br />178円</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border-[5px] flex items-center justify-center" style={{ borderColor: '#c85842' }}>
                          <div className="w-4 h-4 md:w-5 md:h-5 rounded-full border-[4px]" style={{ borderColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">超微粉砕技術で<br />滑らか</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <p className="text-xs md:text-sm font-bold text-gray-800 leading-relaxed">
                        非ゲノム編集・非遺伝子組み換えの国産大豆のプロテイン
                      </p>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-2">
                        <a 
                          href="https://soyproteinranking.com/web/kanzen.php?p=hikaku" 
                          target="_blank" 
                          rel="nofollow noopener"
                          className="inline-block bg-gradient-to-b from-green-500 to-green-700 hover:from-green-600 hover:to-green-800 text-white font-black py-2 px-4 rounded-lg text-xs md:text-sm whitespace-nowrap transition-all cursor-pointer shadow-lg"
                        >
                          公式サイトへ ＞
                        </a>
                      </div>
                    </td>
                  </tr>

                  {/* 4位 */}
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="border border-gray-300 py-4 px-3 text-center relative h-[140px]">
                      <div className="absolute top-0 left-0 w-10 h-10 md:w-12 md:h-16 flex items-center justify-center z-10 shadow-lg" style={{ background: 'linear-gradient(to bottom right, #cd7f32, #b87333, #a0522d)', clipPath: 'polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%)' }}>
                        <span className="text-white font-black text-lg md:text-xl drop-shadow-md" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>4</span>
                      </div>
                      <div className="flex flex-col items-center justify-center pt-2">
                        <a href="https://soyproteinranking.com/web/LYFT.php?p=hikaku" target="_blank" rel="nofollow noopener" className="inline-block mb-2">
                          <img 
                            src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/9e96ca3f24864b70869c9456a6cfd7f2.png" 
                            alt="LYFT" 
                            className="w-[80px] md:w-[90px] h-auto object-contain"
                          />
                        </a>
                        <a href="https://soyproteinranking.com/web/LYFT.php?p=hikaku" target="_blank" rel="nofollow noopener" className="text-sm md:text-base font-bold hover:underline" style={{ color: '#3B82F6' }}>
                          LYFT ＞
                        </a>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                          <div className="w-0 h-0 border-l-[20px] md:border-l-[24px] border-r-[20px] md:border-r-[24px] border-b-[32px] md:border-b-[40px] border-l-transparent border-r-transparent" style={{ borderBottomColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">和風フレーバーで<br />飲みやすい</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                          <div className="w-7 h-7 md:w-8 md:h-8 rounded-full border-[5px]" style={{ borderColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">1杯あたり<br />166円</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                          <div className="w-0 h-0 border-l-[20px] md:border-l-[24px] border-r-[20px] md:border-r-[24px] border-b-[32px] md:border-b-[40px] border-l-transparent border-r-transparent" style={{ borderBottomColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">黒糖きな粉味で<br />極上の喉越し</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <p className="text-xs md:text-sm font-bold text-gray-800 leading-relaxed">
                        重さを感じさせない<br />軽やかな飲み心地
                      </p>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-2">
                        <a 
                          href="https://soyproteinranking.com/web/LYFT.php?p=hikaku" 
                          target="_blank" 
                          rel="nofollow noopener"
                          className="inline-block bg-gradient-to-b from-green-500 to-green-700 hover:from-green-600 hover:to-green-800 text-white font-black py-2 px-4 rounded-lg text-xs md:text-sm whitespace-nowrap transition-all cursor-pointer shadow-lg"
                        >
                          公式サイトへ ＞
                        </a>
                      </div>
                    </td>
                  </tr>

                  {/* 5位 */}
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="border border-gray-300 py-4 px-3 text-center relative h-[140px]">
                      <div className="absolute top-0 left-0 w-10 h-10 md:w-12 md:h-16 flex items-center justify-center z-10 shadow-lg" style={{ background: 'linear-gradient(to bottom right, #cd7f32, #b87333, #a0522d)', clipPath: 'polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%)' }}>
                        <span className="text-white font-black text-lg md:text-xl drop-shadow-md" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>5</span>
                      </div>
                      <div className="flex flex-col items-center justify-center pt-2">
                        <a href="https://soyproteinranking.com/web/beLEGEND.php?p=hikaku" target="_blank" rel="nofollow noopener" className="inline-block mb-2">
                          <img 
                            src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/903004daa56ac975d6b8eee17de03016.jpeg" 
                            alt="be LEGEND" 
                            className="w-[80px] md:w-[90px] h-auto object-contain"
                          />
                        </a>
                        <a href="https://soyproteinranking.com/web/beLEGEND.php?p=hikaku" target="_blank" rel="nofollow noopener" className="text-sm md:text-base font-bold hover:underline" style={{ color: '#3B82F6' }}>
                          be LEGEND ＞
                        </a>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                          <div className="w-0 h-0 border-l-[20px] md:border-l-[24px] border-r-[20px] md:border-r-[24px] border-b-[32px] md:border-b-[40px] border-l-transparent border-r-transparent" style={{ borderBottomColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">インフルエンサー<br />プロデュース</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                          <div className="w-7 h-7 md:w-8 md:h-8 rounded-full border-[5px]" style={{ borderColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">1杯あたり<br />116円</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-1">
                        <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                          <div className="w-0 h-0 border-l-[20px] md:border-l-[24px] border-r-[20px] md:border-r-[24px] border-b-[32px] md:border-b-[40px] border-l-transparent border-r-transparent" style={{ borderBottomColor: '#c85842' }}></div>
                        </div>
                        <p className="text-xs font-bold text-gray-700 leading-tight">濃厚バナナラテ味<br />デザート感覚</p>
                      </div>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <p className="text-xs md:text-sm font-bold text-gray-800 leading-relaxed">
                        身体のめぐりを<br />サポートする大豆の力
                      </p>
                    </td>
                    <td className="border border-gray-300 py-4 px-3 text-center h-[140px]">
                      <div className="flex flex-col items-center justify-center gap-2">
                        <a 
                          href="https://readdy.cc/preview/ec0285b0-09ca-46ac-a979-1c1e9c989e3e/6309291" 
                          target="_blank" 
                          rel="nofollow noopener"
                          className="inline-block bg-gradient-to-b from-green-500 to-green-700 hover:from-green-600 hover:to-green-800 text-white font-black py-2 px-4 rounded-lg text-xs md:text-sm whitespace-nowrap transition-all cursor-pointer shadow-lg"
                        >
                          公式サイトへ ＞
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="mt-6 md:mt-8 text-xs md:text-sm text-gray-600 leading-relaxed bg-gray-50 rounded-lg p-4 border border-gray-200">
              <p className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5" style={{ color: '#c85842' }}></i>
                <span>※価格は各商品の公式サイトを参照しています。※</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Ranking List Section */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-block mb-4">
              <span className="text-white text-sm font-bold px-6 py-2 rounded-full shadow-lg" style={{ backgroundColor: '#c85842' }}>
                編集部が厳選！
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-800 mb-4">
              女性におすすめ<br />
              <span style={{ color: '#d64E39' }}>ソイプロテイン</span>
              <span className="text-3xl">5選！</span>
            </h2>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
              あなたにぴったりの商品が見つかる！
            </p>
          </div>

          {/* 1位 SOY it protein */}
          <div className="mb-12 rounded-2xl shadow-xl overflow-hidden border-4 border-yellow-400" style={{ backgroundColor: '#fef9c3' }}>
            <div className="px-6 py-4 flex items-center" style={{ background: 'linear-gradient(to right, #f6c344, #c85842)' }}>
              <div className="relative w-16 h-16 mr-4">
                <div className="absolute inset-0 rounded-full shadow-lg" style={{ background: 'linear-gradient(to bottom right, #f6c344, #c85842)' }}></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-4xl font-black text-white drop-shadow-lg" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>1</span>
                </div>
                <div className="absolute -top-1 -right-1 w-6 h-6 bg-yellow-200 rounded-full opacity-50"></div>
              </div>
              <a href="https://soyproteinranking.com/web/SOYit.php?p=rank" target="_blank" rel="nofollow noopener" className="text-2xl font-bold text-white underline">
                SOY it protein ＞
              </a>
            </div>

            <div className="p-6">
              <a href="https://soyproteinranking.com/web/SOYit.php?p=rank" target="_blank" rel="nofollow noopener">
                <img 
                  src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/89c8b4abb18bdf6080fbf335e0f9d6f8.png" 
                  alt="SOY it protein" 
                  className="w-full rounded-lg shadow-md mb-4"
                  width={800}
                  height={400}
                />
              </a>

              <div className="bg-white rounded-lg p-6 mb-6 shadow-md overflow-x-auto">
                <table className="w-full text-sm">
                  <tbody>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">1杯あたりの金額</th>
                      <td className="py-3 break-words">約99円〜</td>
                    </tr>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">定期便初回総額(税込)</th>
                      <td className="py-3 break-words">1,480円（クーポン適用時）</td>
                    </tr>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">期待できる効果や成分</th>
                      <td className="py-3 break-words">脂肪の燃焼を助ける成分（機能性表示食品）、<br className="hidden md:inline"/>ソイプロテイン、1日分のビタミン</td>
                    </tr>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">美味しさや飲みやすさ</th>
                      <td className="py-3 break-words">シェイカー不要。スプーンで混ぜるだけで<br className="hidden md:inline"/>サッと溶けるカフェラテ味</td>
                    </tr>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">販売実績</th>
                      <td className="py-3 break-words">シリーズ累計1,200万個突破</td>
                    </tr>
                    <tr>
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">公式サイト</th>
                      <td className="py-3 break-all">
                        <a href="https://soyproteinranking.com/web/SOYit.php?p=rank" target="_blank" rel="noopener" className="hover:underline font-bold" style={{ color: '#0000ff' }}>
                          https://soyproteinranking.com/web/SOYit.php
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="bg-primary-light rounded-lg p-6 mb-6">
                <div className="mb-4 flex items-center gap-3">
                  <div className="w-2 h-8 rounded-full" style={{ background: 'linear-gradient(to bottom, #d46a56, #c85842)' }}></div>
                  <h3 className="text-2xl font-black text-gray-800 tracking-wide">
                    おすすめポイント
                  </h3>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-3">脂肪の燃焼をサポート！シェイカー不要で溶ける手軽さが魅力</h4>
                <p className="text-sm text-gray-700 leading-relaxed">
                  SOYit（ソイット）は、シリーズ累計1,200万個を突破した実績あるブランドの機能性表示食品です。脂肪の燃焼を助ける成分を配合しており、ボディメイクを効率よくサポートします。<br/><br/>
                  特筆すべきは、プロテイン選びで最も重要な「味」に徹底的にこだわった「溶けやすさ」です。シェイカーを使わずともコップとスプーンだけで溶けるため、準備や片付けの手間が一切かかりません。今ならクーポン利用で初回1,480円から、手軽に本格的なボディメイクを始められます。<br/>※シリーズ累計：2013年12月~2024年8月のグループ累計本数による
                </p>
              </div>

              <div className="rounded-lg p-6 text-center text-white" style={{ background: 'linear-gradient(to right, #c85842, #d46a56)' }}>
                <p className="text-sm mb-3 font-bold">シリーズ累計1,200万個突破</p>
                <div className="flex flex-col items-center">
                  <a href="https://soyproteinranking.com/web/SOYit.php?p=rank" target="_blank" rel="blank noopener" className="inline-block mb-4">
                    <img 
                      src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/e3ef22b7eb39d879063a34d1367fe5c1.jpeg" 
                      alt="SOY it protein" 
                      className="bg-white rounded-lg p-2"
                      width={140}
                      height={45}
                    />
                  </a>
                  <a 
                    href="https://soyproteinranking.com/web/SOYit.php?p=rank" 
                    target="_blank" 
                    rel="nofollow noopener"
                    className="relative overflow-hidden inline-block bg-white font-bold py-3 px-8 rounded-full hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                    style={{ color: '#c85842' }}
                  >
                    <span className="absolute inset-0 overflow-hidden rounded-full">
                      <span className="absolute inset-0 -translate-x-full animate-[shine_2s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-[#c85842]/30 to-transparent"></span>
                    </span>
                    <span className="relative">SOY it proteinの詳細を見る</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* 2位 KOREDAKE */}
          <div className="mb-12 bg-gradient-to-br from-primary-light to-primary rounded-2xl shadow-xl overflow-hidden border-4 border-primary">
            <div className="bg-gradient-to-r from-primary to-primary-dark px-6 py-4 flex items-center">
              <div className="relative w-16 h-16 mr-4">
                <div className="absolute inset-0 bg-gradient-to-br from-gray-200 to-gray-400 rounded-full shadow-lg"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-4xl font-black text-white drop-shadow-lg" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>2</span>
                </div>
                <div className="absolute -top-1 -right-1 w-6 h-6 bg-gray-300 rounded-full opacity-50"></div>
              </div>
              <a href="https://soyproteinranking.com/web/KOREDAKE.php?p=rank" target="_blank" rel="nofollow noopener" className="text-2xl font-bold text-white underline">
                KOREDAKE ＞
              </a>
            </div>

            <div className="p-6">
              <a href="https://soyproteinranking.com/web/KOREDAKE.php?p=rank" target="_blank" rel="nofollow noopener">
                <img 
                  src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/93b4b79c66e86cb9f9e87991db8dae03.png" 
                  alt="KOREDAKE" 
                  className="w-full rounded-lg shadow-md mb-4"
                  width={800}
                  height={400}
                />
              </a>

              <div className="bg-white rounded-lg p-6 mb-6 shadow-md overflow-x-auto">
                <table className="w-full text-sm">
                  <tbody>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">1杯あたりの金額</th>
                      <td className="py-3 break-words">約197円〜</td>
                    </tr>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">定期便初回総額(税込)</th>
                      <td className="py-3 break-words">1,480円</td>
                    </tr>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">期待できる効果や成分</th>
                      <td className="py-3 break-words">14種類＋αの栄養素、<br className="hidden md:inline"/>アフリカマンゴノキ、MCTオイル、食物繊維、酵母など</td>
                    </tr>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">美味しさや飲みやすさ</th>
                      <td className="py-3 break-words">人工甘味料不使用の自然な甘み。<br className="hidden md:inline"/>まろやかで飽きない美味しさ</td>
                    </tr>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">販売実績</th>
                      <td className="py-3 break-words">累計販売数100万食突破</td>
                    </tr>
                    <tr>
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">公式サイト</th>
                      <td className="py-3 break-all">
                        <a href="https://readdy.cc/preview/2ecd2b52-32b9-4ad2-89d7-448bb5097ea2/6309244" target="_blank" rel="noopener" className="hover:underline font-bold" style={{ color: '#0000ff' }}>
                          https://readdy.cc/preview/2ecd2b52-32b9-4ad2-89d7-448bb5097ea2/6309244
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="bg-primary-light rounded-lg p-6 mb-6">
                <div className="mb-4 flex items-center gap-3">
                  <div className="w-2 h-8 bg-gradient-to-b from-primary to-primary-dark rounded-full"></div>
                  <h3 className="text-2xl font-black text-gray-800 tracking-wide">
                    おすすめポイント
                  </h3>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-3">これ1杯で1日分以上の栄養をカバー！美容成分も贅沢配合</h4>
                <p className="text-sm text-gray-700 leading-relaxed">
                  KOREDAKEは、たんぱく質だけでなく、女性に不足しがちな鉄分や葉酸、さらには美容成分まで31種類を凝縮した「完全栄養プロテイン」です。これだけで食事代わりになるほど栄養バランスが整っています。<br/><br/>
                  最大の特徴は、人工甘味料や保存料を一切使わない「100%植物性」へのこだわり。プロテイン独特の風味がなく、素材本来の美味しさを楽しめます。忙しい毎日の中で、美しく健康的なライフスタイルを維持したい方に最適な一品です。
                </p>
              </div>

              <div className="bg-gradient-to-r from-primary to-primary-dark rounded-lg p-6 text-center text-white">
                <p className="text-sm mb-3 font-bold">累計販売数100万食突破</p>
                <div className="flex flex-col items-center">
                  <a href="https://readdy.cc/preview/2ecd2b52-32b9-4ad2-89d7-448bb5097ea2/6309244" target="_blank" rel="nofollow noopener" className="inline-block mb-4">
                    <img 
                      src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/4b93aca810e4558fe1cbf6744b2f8107.png" 
                      alt="KOREDAKE" 
                      className="bg-white rounded-lg p-2"
                      width={140}
                      height={45}
                    />
                  </a>
                  <a 
                    href="https://readdy.cc/preview/2ecd2b52-32b9-4ad2-89d7-448bb5097ea2/6309244" 
                    target="_blank" 
                    rel="nofollow noopener"
                    className="relative overflow-hidden inline-block bg-white text-primary-dark font-bold py-3 px-8 rounded-full hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <span className="absolute inset-0 overflow-hidden rounded-full">
                      <span className="absolute inset-0 -translate-x-full animate-[shine_2s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-primary/30 to-transparent"></span>
                    </span>
                    <span className="relative">KOREDAKEの詳細を見る</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* 3位 私の完全美容食 */}
          <div className="mb-12 bg-gradient-to-br from-primary-light to-primary rounded-2xl shadow-xl overflow-hidden border-4 border-primary">
            <div className="bg-gradient-to-r from-primary to-primary-dark px-6 py-4 flex items-center">
              <div className="relative w-16 h-16 mr-4">
                <div className="absolute inset-0 bg-gradient-to-br from-amber-500 to-amber-700 rounded-full shadow-lg"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-4xl font-black text-white drop-shadow-lg" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>3</span>
                </div>
                <div className="absolute -top-1 -right-1 w-6 h-6 bg-amber-300 rounded-full opacity-50"></div>
              </div>
              <a href="https://soyproteinranking.com/web/kanzen.php?p=rank" target="_blank" rel="nofollow noopener" className="text-2xl font-bold text-white underline">
                私の完全美容食 ＞
              </a>
            </div>

            <div className="p-6">
              <a href="https://soyproteinranking.com/web/kanzen.php?p=rank" target="_blank" rel="nofollow noopener">
                <img 
                  src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/3ddd47ebdc67a7a178cbb119d9790613.png" 
                  alt="私の完全美容食" 
                  className="w-full rounded-lg shadow-md mb-4"
                  width={800}
                  height={400}
                />
              </a>

              <div className="bg-white rounded-lg p-6 mb-6 shadow-md overflow-x-auto">
                <table className="w-full text-sm">
                  <tbody>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">1杯あたりの金額</th>
                      <td className="py-3 break-words">約178円〜</td>
                    </tr>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">定期便初回総額(税込)</th>
                      <td className="py-3 break-words">4,980円（※1袋買うともう1袋プレゼント中）</td>
                    </tr>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">期待できる効果や成分</th>
                      <td className="py-3 break-words">国産大豆100%（非遺伝子組み換え）、<br className="hidden md:inline"/>大豆イソフラボン、鉄分、葉酸、食物繊維</td>
                    </tr>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">美味しさや飲みやすさ</th>
                      <td className="py-3 break-words">超微粉砕技術でダマにならず滑らか。<br className="hidden md:inline"/>沖縄県産黒糖を使用した自然な甘さ</td>
                    </tr>
                    <tr className="border-b">
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">販売実績</th>
                      <td className="py-3 break-words">管理栄養士推奨・試飲会人気No.1</td>
                    </tr>
                    <tr>
                      <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">公式サイト</th>
                      <td className="py-3 break-all">
                        <a href="https://soyproteinranking.com/web/kanzen.php?p=rank" target="_blank" rel="noopener" className="hover:underline font-bold" style={{ color: '#0000ff' }}>
                          https://soyproteinranking.com/web/kanzen.php
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="bg-primary-light rounded-lg p-6 mb-6">
                <div className="mb-4 flex items-center gap-3">
                  <div className="w-2 h-8 bg-gradient-to-b from-primary to-primary-dark rounded-full"></div>
                  <h3 className="text-2xl font-black text-gray-800 tracking-wide">
                    おすすめポイント
                  </h3>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-3">国産大豆の恵みをまるごと！美容と健康を支える「飲む美容液」</h4>
                <p className="text-sm text-gray-700 leading-relaxed">
                  私の完全美容食は、北海道産大豆をはじめとした厳選された国産素材にこだわった、女性のためのソイプロテインです。合成甘味料や香料を一切使用せず、素材本来の旨みと黒糖のやさしい甘さで、毎日飽きずに飲み続けられます。<br/><br/>
                  独自の「超微粉砕技術」により、粒子が非常に細かくスッと溶けるため、口当たりの良さは抜群。たんぱく質だけでなく、女性が不足しがちな鉄分や葉酸、食物繊維も1杯でしっかり補給できます。今なら定期便限定で「1袋買うともう1袋無料」のキャンペーン中。圧倒的なコスパで本格的な美容習慣をスタートできます。
                </p>
              </div>

              <div className="bg-gradient-to-r from-primary to-primary-dark rounded-lg p-6 text-center text-white">
                <p className="text-sm mb-3 font-bold">管理栄養士推奨・試飲会人気No.1</p>
                <div className="flex flex-col items-center">
                  <a href="https://soyproteinranking.com/web/kanzen.php?p=rank" target="_blank" rel="nofollow noopener" className="inline-block mb-4">
                    <img 
                      src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/3e08286b8bfd25095d7fdbea894f1c87.jpeg" 
                      alt="私の完全美容食" 
                      className="bg-white rounded-lg p-2 h-[45px] object-contain"
                      width={140}
                      height={45}
                    />
                  </a>
                  <a 
                    href="https://soyproteinranking.com/web/kanzen.php?p=rank" 
                    target="_blank" 
                    rel="nofollow noopener"
                    className="relative overflow-hidden inline-block bg-white text-primary-dark font-bold py-3 px-8 rounded-full hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <span className="absolute inset-0 overflow-hidden rounded-full">
                      <span className="absolute inset-0 -translate-x-full animate-[shine_2s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-primary/30 to-transparent"></span>
                    </span>
                    <span className="relative">私の完全美容食の詳細を見る</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* 4位以下を見るボタン */}
          <div className="text-center mb-8">
            <button
              onClick={() => setShowMore(!showMore)}
              className="bg-gradient-to-r from-primary to-primary-dark hover:from-primary-dark hover:to-primary text-white font-bold py-4 px-12 rounded-full text-lg shadow-lg transition-all cursor-pointer whitespace-nowrap"
            >
              {showMore ? '4位以下を閉じる' : '4位以下をみる'}
            </button>
          </div>

          {/* 4位以下 */}
          {showMore && (
            <div className="space-y-12">
              {/* 4位 LYFT */}
              <div className="bg-gradient-to-br from-primary-light to-primary rounded-2xl shadow-xl overflow-hidden border-4 border-primary">
                <div className="bg-gradient-to-r from-primary to-primary-dark px-6 py-4 flex items-center">
                  <div className="relative w-16 h-16 mr-4">
                    <div className="absolute inset-0 bg-gradient-to-br from-gray-300 to-gray-500 rounded-full shadow-lg"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <span className="text-4xl font-black text-white drop-shadow-lg" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>4</span>
                    </div>
                    <div className="absolute -top-1 -right-1 w-6 h-6 bg-gray-400 rounded-full opacity-50"></div>
                  </div>
                  <a href="https://soyproteinranking.com/web/LYFT.php?p=rank" target="_blank" rel="nofollow noopener" className="text-2xl font-bold text-white underline">
                    LÝFT ＞
                  </a>
                </div>

                <div className="p-6">
                  <a href="https://soyproteinranking.com/web/LYFT.php?p=rank" target="_blank" rel="nofollow noopener">
                    <img 
                      src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/9e96ca3f24864b70869c9456a6cfd7f2.png" 
                      alt="LÝFT" 
                      className="w-full rounded-lg shadow-md mb-4"
                      width={800}
                      height={400}
                    />
                  </a>

                  <div className="bg-white rounded-lg p-6 mb-6 shadow-md overflow-x-auto">
                    <table className="w-full text-sm">
                      <tbody>
                        <tr className="border-b">
                          <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">1杯あたりの金額</th>
                          <td className="py-3 break-words">約242円〜</td>
                        </tr>
                        <tr className="border-b">
                          <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">定期便初回総額(税込)</th>
                          <td className="py-3 break-words">4,750円（500gパック定期便価格）</td>
                        </tr>
                        <tr className="border-b">
                          <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">期待できる効果や成分</th>
                          <td className="py-3 break-words">22種類の栄養素（ビタミン・ミネラル・亜鉛）、<br className="hidden md:inline"/>スポーツ乳酸菌300億個、大豆イソフラボン</td>
                        </tr>
                        <tr className="border-b">
                          <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">美味しさや飲みやすさ</th>
                          <td className="py-3 break-words">プロテインを忘れるほどの「黒糖きな粉味」。<br className="hidden md:inline"/>ソイ特有のザラつきを抑えた極上の喉越し</td>
                        </tr>
                        <tr className="border-b">
                          <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">販売実績</th>
                          <td className="py-3 break-words">エドワード加藤監修・フィットネス業界屈指の人気ブランド</td>
                        </tr>
                        <tr>
                          <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">公式サイト</th>
                          <td className="py-3 break-all">
                            <a href="https://soyproteinranking.com/web/LYFT.php?p=rank" target="_blank" rel="noopener" className="hover:underline font-bold" style={{ color: '#0000ff' }}>
                              https://soyproteinranking.com/web/LYFT.php
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="bg-primary-light rounded-lg p-6 mb-6">
                    <div className="mb-4 flex items-center gap-3">
                      <div className="w-2 h-8 bg-gradient-to-b from-primary to-primary-dark rounded-full"></div>
                      <h3 className="text-2xl font-black text-gray-800 tracking-wide">
                        おすすめポイント
                      </h3>
                    </div>
                    <h4 className="text-lg font-bold text-gray-800 mb-3">プロテインの概念を覆す美味しさ！1食に必要な栄養を凝縮した完全栄養食</h4>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      LÝFT（リフト）のソイプロテインは、「プロテインを感じさせない」をコンセプトに、和菓子のような本格的な「黒糖きな粉味」を徹底再現しました。運動後だけでなく、朝食代わりや就寝前の「ご褒美」としても楽しめるクオリティです。<br/><br/>
                      管理栄養士監修のもと、1食に必要な22種類のビタミン・ミネラルに加え、パフォーマンスを支えるスポーツ乳酸菌を300億個も配合。これ1杯で日々の健康と美容をトータルサポートします。本物志向の味と高い栄養価を両立させたい方に、自信を持っておすすめできる最高峰のソイプロテインです。
                    </p>
                  </div>

                  <div className="bg-gradient-to-r from-primary to-primary-dark rounded-lg p-6 text-center text-white">
                    <p className="text-sm mb-3 font-bold">エドワード加藤監修</p>
                    <div className="flex flex-col items-center">
                      <a href="https://soyproteinranking.com/web/LYFT.php?p=rank" target="_blank" rel="nofollow noopener" className="inline-block mb-4">
                        <img 
                          src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/8786d3b1157d3a3e96036f60468dce64.jpeg" 
                          alt="LÝFT" 
                          className="bg-white rounded-lg p-2"
                          width={140}
                          height={45}
                        />
                      </a>
                      <a 
                        href="https://soyproteinranking.com/web/LYFT.php?p=rank" 
                        target="_blank" 
                        rel="nofollow noopener"
                        className="relative overflow-hidden inline-block bg-white text-primary-dark font-bold py-3 px-8 rounded-full hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <span className="absolute inset-0 overflow-hidden rounded-full">
                          <span className="absolute inset-0 -translate-x-full animate-[shine_2s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-primary/30 to-transparent"></span>
                        </span>
                        <span className="relative">LÝFTの詳細を見る</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* 5位 be LEGEND */}
              <div className="bg-gradient-to-br from-primary-light to-primary rounded-2xl shadow-xl overflow-hidden border-4 border-primary">
                <div className="bg-gradient-to-r from-primary to-primary-dark px-6 py-4 flex items-center">
                  <div className="relative w-16 h-16 mr-4">
                    <div className="absolute inset-0 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full shadow-lg"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <span className="text-4xl font-black text-white drop-shadow-lg" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>5</span>
                    </div>
                    <div className="absolute -top-1 -right-1 w-6 h-6 bg-gray-500 rounded-full opacity-50"></div>
                  </div>
                  <a href="https://readdy.cc/preview/ec0285b0-09ca-46ac-a979-1c1e9c989e3e/6309291" target="_blank" rel="nofollow noopener" className="text-2xl font-bold text-white underline">
                    be LEGEND ＞
                  </a>
                </div>

                <div className="p-6">
                  <a href="https://readdy.cc/preview/ec0285b0-09ca-46ac-a979-1c1e9c989e3e/6309291" target="_blank" rel="nofollow noopener">
                    <img 
                      src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/475fe4cc986637cd50dc1725a9db8d5f.png" 
                      alt="be LEGEND" 
                      className="w-full rounded-lg shadow-md mb-4"
                      width={800}
                      height={400}
                    />
                  </a>

                  <div className="bg-white rounded-lg p-6 mb-6 shadow-md overflow-x-auto">
                    <table className="w-full text-sm">
                      <tbody>
                        <tr className="border-b">
                          <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">1杯あたりの金額</th>
                          <td className="py-3 break-words">約128円〜</td>
                        </tr>
                        <tr className="border-b">
                          <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">定期便初回総額(税込)</th>
                          <td className="py-3 break-words">3,840円（※通常購入価格から10%OFF適用時）</td>
                        </tr>
                        <tr className="border-b">
                          <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">期待できる効果や成分</th>
                          <td className="py-3 break-words">ソイプロテイン、サポニン（大豆由来）、<br className="hidden md:inline"/>10種のビタミン、カルシウム、鉄分</td>
                        </tr>
                        <tr className="border-b">
                          <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">美味しさや飲みやすさ</th>
                          <td className="py-3 break-words">プロテインとは思えない「濃厚バナナラテ味」。<br className="hidden md:inline"/>水で溶いてもコクがある飲みやすさ</td>
                        </tr>
                        <tr className="border-b">
                          <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">販売実績</th>
                          <td className="py-3 break-words">モンドセレクション最高金賞受賞・アンチドーピング認証取得</td>
                        </tr>
                        <tr>
                          <th className="text-left py-3 pr-4 font-bold text-gray-700 min-w-[100px] align-top">公式サイト</th>
                          <td className="py-3 break-all">
                            <a href="https://readdy.cc/preview/ec0285b0-09ca-46ac-a979-1c1e9c989e3e/6309291" target="_blank" rel="noopener" className="hover:underline font-bold" style={{ color: '#0000ff' }}>
                              https://readdy.cc/preview/ec0285b0-09ca-46ac-a979-1c1e9c989e3e/6309291
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="bg-primary-light rounded-lg p-6 mb-6">
                    <div className="mb-4 flex items-center gap-3">
                      <div className="w-2 h-8 bg-gradient-to-b from-primary to-primary-dark rounded-full"></div>
                      <h3 className="text-2xl font-black text-gray-800 tracking-wide">
                        おすすめポイント
                      </h3>
                    </div>
                    <h4 className="text-lg font-bold text-gray-800 mb-3">「美味しいから続けられる」を追求！品質とコスパを両立した実力派</h4>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      ビーレジェンドのウェイトダウンシリーズは、プロテイン選びで最も重要な「味」に徹底的にこだわったソイプロテインです。今回ピックアップした「濃厚バナナラテ味」は、ソイ特有の癖を抑え、デザート感覚で美味しく飲めるのが最大の特徴です。<br/><br/>
                      品質面でも妥協はなく、ビタミンや鉄分をバランスよく配合。さらにアンチドーピング認証（インフォームドチョイス）を取得しており、アスリートからダイエット目的の初心者まで安心して愛用できます。1杯約128円という高いコストパフォーマンスも、長く習慣化したい方に選ばれる理由です。
                    </p>
                  </div>

                  <div className="bg-gradient-to-r from-primary to-primary-dark rounded-lg p-6 text-center text-white">
                    <p className="text-sm mb-3 font-bold">モンドセレクション最高金賞受賞</p>
                    <div className="flex flex-col items-center">
                      <a href="https://readdy.cc/preview/ec0285b0-09ca-46ac-a979-1c1e9c989e3e/6309291" target="_blank" rel="nofollow noopener" className="inline-block mb-4">
                        <img 
                          src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/903004daa56ac975d6b8eee17de03016.jpeg" 
                          alt="be LEGEND" 
                          className="bg-white rounded-lg p-2"
                          width={140}
                          height={45}
                        />
                      </a>
                      <a 
                        href="https://readdy.cc/preview/ec0285b0-09ca-46ac-a979-1c1e9c989e3e/6309291" 
                        target="_blank" 
                        rel="nofollow noopener"
                        className="relative overflow-hidden inline-block bg-white text-primary-dark font-bold py-3 px-8 rounded-full hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <span className="absolute inset-0 overflow-hidden rounded-full">
                          <span className="absolute inset-0 -translate-x-full animate-[shine_2s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-primary/30 to-transparent"></span>
                        </span>
                        <span className="relative">be LEGENDの詳細を見る</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 px-4 bg-gradient-to-b from-primary-light to-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4">
            よくあるご質問
          </h2>
          <p className="text-center text-gray-600 mb-12">
            お客様からよくいただくご質問をまとめました
          </p>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-xl shadow-md border-2 border-primary overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-primary-light transition-colors cursor-pointer"
                >
                  <div className="flex items-start gap-3 flex-1">
                    <div className="w-8 h-8 bg-primary-dark rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-white font-bold text-sm">Q</span>
                    </div>
                    <span className="font-bold text-gray-800 text-lg">{faq.question}</span>
                  </div>
                  <i className={`ri-arrow-down-s-line text-2xl text-primary-dark transition-transform flex-shrink-0 ml-4 ${openIndex === index ? 'rotate-180' : ''}`}></i>
                </button>
                
                {openIndex === index && (
                  <div className="px-6 pb-5 bg-primary-light">
                    <div className="flex items-start gap-3 pl-11">
                      <div className="w-8 h-8 bg-primary-dark rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-white font-bold text-sm">A</span>
                      </div>
                      <p className="text-gray-700 leading-relaxed pt-1">{faq.answer}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="text-white py-12" style={{ backgroundColor: '#663817' }}>
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            {/* 商品一覧 */}
            <div>
              <h3 className="text-lg font-bold mb-4 pb-2 border-b border-gray-700">商品一覧</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="./pages/SOY it protein/" className="hover:text-primary transition-colors">
                    SOY it protein
                  </a>
                </li>
                <li>
                  <a href="./pages/KOREDAKE/" className="hover:text-primary transition-colors">
                    KOREDAKE
                  </a>
                </li>
                <li>
                  <a href="./pages/私の完全美容食/" className="hover:text-primary transition-colors">
                    私の完全美容食
                  </a>
                </li>
                <li>
                  <a href="./pages/LYFT/" className="hover:text-primary transition-colors">
                    LYFT
                  </a>
                </li>
                <li>
                  <a href="./pages/beLEGEND SOY/" className="hover:text-primary transition-colors">
                    beLEGEND
                  </a>
                </li>
              </ul>
            </div>

            {/* コラム一覧 */}
            <div>
              <h3 className="text-lg font-bold mb-4 pb-2 border-b border-gray-700">コラム一覧</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="./column/ソイプロテインとは？ホエイとの違いや特徴・利点を徹底解説/" className="hover:text-primary transition-colors">
                    ソイプロテインとは？ホエイとの違いや特徴・利点を徹底解説
                  </a>
                </li>
                <li>
                  <a href="./column/初めてのソイプロテイン選び！失敗しないチェックポイントと基準/" className="hover:text-primary transition-colors">
                    初めてのソイプロテイン選び！失敗しないチェックポイントと基準
                  </a>
                </li>
                <li>
                  <a href="./column/ソイプロテインの飲むタイミングは？目的別の効果的な飲み方/" className="hover:text-primary transition-colors">
                    ソイプロテインの飲むタイミングは？目的別の効果的な飲み方
                  </a>
                </li>
                <li>
                  <a href="./column/女性らしい体を作る！ソイプロテインがボディメイクに最適な理由/" className="hover:text-primary transition-colors">
                    女性らしい体を作る！ソイプロテインがボディメイクに最適な理由
                  </a>
                </li>
                <li>
                  <a href="./column/大人の女性こそソイ！健康維持に役立つ大豆タンパク質の力とは/" className="hover:text-primary transition-colors">
                    大人の女性こそソイ！健康維持に役立つ大豆タンパク質の力とは
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* フッター下部 */}
          <div className="border-t border-gray-700 pt-6">
            <div className="flex flex-wrap justify-center gap-4 text-xs mb-4">
              <a href="./pages/運営会社/" className="hover:text-primary transition-colors" rel="noopener nofollow">
                運営会社
              </a>
              <span className="text-gray-600">|</span>
              <a href="./pages/調査概要/" className="hover:text-primary transition-colors" rel="noopener nofollow">
                調査概要
              </a>
              <span className="text-gray-600">|</span>
            </div>
            <p className="text-center text-xs text-gray-500">© soyproteinranking.com</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
